import { makeStyles } from '@mui/styles';

const useTraitContentStyle = makeStyles(() => ({
  container: {
    paddingTop: '32px',
  },
}));

export default useTraitContentStyle;
